export default __webpack_public_path__ + "static/media/vert-menu.6347800a.png";